module.exports = __webpack_public_path__ + "img/Barak.a85814fe.jpeg";